// extracted by mini-css-extract-plugin
module.exports = {"toggle":"_d508394","label":"_9d567d5"};